import React from 'react';

const API = `${(process.env.REACT_APP_BACKEND_URL || 'https://bobine.live')}/api`;

const DuplicatesModal = ({
  duplicateGroups, dupToDelete, toggleDupDelete,
  handleDeleteDuplicates, dupDeleting, onClose, token, t,
}) => (
  <div data-testid="duplicates-modal" onClick={onClose} style={{
    position: 'fixed', inset: 0, zIndex: 999, backgroundColor: 'rgba(0,0,0,0.92)',
    display: 'flex', alignItems: 'center', justifyContent: 'center',
    padding: 20,
  }}>
    <div onClick={e => e.stopPropagation()} style={{
      backgroundColor: '#0a0a0a', borderRadius: 16,
      border: '1px solid rgba(212,175,55,0.2)',
      maxWidth: 700, width: '100%', maxHeight: '85vh', overflow: 'hidden',
      display: 'flex', flexDirection: 'column',
    }}>
      {/* Header */}
      <div style={{
        padding: '24px 24px 16px', borderBottom: '1px solid rgba(212,175,55,0.1)',
        display: 'flex', alignItems: 'center', justifyContent: 'space-between',
      }}>
        <div>
          <p style={{ fontFamily: "'Georgia', serif", fontSize: 18, color: '#D4AF37', fontWeight: 600, margin: 0 }}>
            {t('dup_title')}
          </p>
          <p style={{ fontFamily: "'Georgia', serif", fontSize: 12, color: '#FAF3E0', marginTop: 4 }}>
            {t('dup_select_to_delete')}
          </p>
        </div>
        <button data-testid="duplicates-close-btn" onClick={onClose} style={{
          background: 'rgba(212,175,55,0.08)', border: '1px solid rgba(212,175,55,0.35)',
          borderRadius: '50%', cursor: 'pointer', color: '#D4AF37', padding: 6,
          width: 36, height: 36, display: 'flex', alignItems: 'center', justifyContent: 'center',
        }}>
          <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#D4AF37" strokeWidth="2.5" strokeLinecap="round"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>
        </button>
      </div>

      {/* Duplicate groups */}
      <div style={{ padding: '16px 24px', overflowY: 'auto', flex: 1 }}>
        {duplicateGroups.map((group, gi) => (
          <div key={group.hash} data-testid={`dup-group-${gi}`} style={{
            marginBottom: 24, padding: '16px', borderRadius: 12,
            backgroundColor: 'rgba(212,175,55,0.03)',
            border: '1px solid rgba(212,175,55,0.12)',
          }}>
            <p style={{ fontFamily: "'Georgia', serif", fontSize: 12, color: '#D4AF37', marginBottom: 12, textTransform: 'uppercase', letterSpacing: 1.5 }}>
              {t('dup_group')} {gi + 1} — {group.count} {t('dup_identical')}
            </p>
            <div style={{ display: 'grid', gridTemplateColumns: `repeat(${Math.min(group.photos.length, 4)}, 1fr)`, gap: 10 }}>
              {group.photos.map((photo, pi) => {
                const isMarked = dupToDelete.has(photo.id);
                return (
                  <div key={photo.id} data-testid={`dup-photo-${photo.id}`}
                    onClick={() => toggleDupDelete(photo.id)}
                    style={{
                      position: 'relative', borderRadius: 10, overflow: 'hidden',
                      cursor: 'pointer', aspectRatio: '1 / 1',
                      border: isMarked ? '2px solid #e74c3c' : '1px solid rgba(212,175,55,0.15)',
                      opacity: isMarked ? 0.5 : 1,
                      transition: 'all 0.2s',
                    }}
                  >
                    <img
                      src={`${API}/photos/${photo.id}/thumbnail?token=${token}`}
                      alt="" loading="lazy"
                      onLoad={e => { e.target.style.opacity = '1'; }}
                      onError={e => { e.target.style.opacity = '0.3'; e.target.src = '/bobine-face-logo.png'; e.target.style.objectFit = 'contain'; e.target.style.padding = '25%'; }}
                      style={{ width: '100%', height: '100%', objectFit: 'cover', opacity: 0, transition: 'opacity 0.3s', display: 'block' }}
                    />
                    {isMarked && (
                      <div style={{
                        position: 'absolute', inset: 0,
                        backgroundColor: 'rgba(231,76,60,0.3)',
                        display: 'flex', alignItems: 'center', justifyContent: 'center',
                      }}>
                        <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="#e74c3c" strokeWidth="2.5" strokeLinecap="round"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>
                      </div>
                    )}
                    {!isMarked && pi === 0 && (
                      <div style={{
                        position: 'absolute', top: 4, left: 4, padding: '2px 8px', borderRadius: 4,
                        backgroundColor: 'rgba(46,204,113,0.15)', border: '1px solid rgba(46,204,113,0.3)',
                      }}>
                        <span style={{ fontFamily: "'Georgia', serif", fontSize: 9, color: '#2ecc71', fontWeight: 600 }}>{t('dup_keep')}</span>
                      </div>
                    )}
                    <div style={{
                      position: 'absolute', bottom: 0, left: 0, right: 0, padding: '4px 6px',
                      background: 'linear-gradient(transparent, rgba(0,0,0,0.8))',
                    }}>
                      <span style={{ fontFamily: "'Georgia', serif", fontSize: 9, color: '#FAF3E0' }}>
                        {photo.filename?.substring(0, 15)}
                      </span>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        ))}
      </div>

      {/* Footer */}
      <div style={{
        padding: '16px 24px', borderTop: '1px solid rgba(212,175,55,0.1)',
        display: 'flex', alignItems: 'center', justifyContent: 'space-between',
      }}>
        <span style={{ fontFamily: "'Georgia', serif", fontSize: 12, color: '#D4AF37' }}>
          {dupToDelete.size} {t('ecl_selected_plural')}
        </span>
        <button data-testid="dup-delete-btn" onClick={handleDeleteDuplicates}
          disabled={dupToDelete.size === 0 || dupDeleting}
          style={{
            fontFamily: "'Georgia', serif", fontSize: 14, fontWeight: 600,
            padding: '12px 28px', borderRadius: 8, cursor: dupToDelete.size === 0 ? 'not-allowed' : 'pointer',
            backgroundColor: dupToDelete.size > 0 ? '#e74c3c' : 'rgba(231,76,60,0.15)',
            color: dupToDelete.size > 0 ? '#FAF3E0' : 'rgba(231,76,60,0.4)',
            border: 'none', transition: 'all 0.3s',
            opacity: dupDeleting ? 0.6 : 1,
          }}
        >
          {dupDeleting ? t('dash_batch_deleting') : `${t('dup_delete_selected')} (${dupToDelete.size})`}
        </button>
      </div>
    </div>
  </div>
);

export default DuplicatesModal;
